import React from 'react'

import ChatRoomPage from './pages/chat/chat-room-page/index'
const Chat = () => {
  return (
    <div
      style={{
        height: '100vh',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        padding: '20px',
        background: '#DDDBD1',
      }}
    >
      <ChatRoomPage />
    </div>
  )
}
export default Chat
